import { ReactComponent as IconDashboard } from "assets/svg/menu-dashboard.svg"

import { MenuItem } from ".."

export const EnterpriseMenu = () => <MenuItem to="/dashboard" icon={<IconDashboard />} label="Dashboard" />
